import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import { NoteView } from '@repo/components/notes';
import Note from '@repo/utils/models/Note';

export const NotesList = ({
  notes,
  creatingNewNote,
  currentlyEditingNote,
  clearNewNote,
  deleteNote,
  setCurrentlyEditing,
  clearCurrentlyEditing,
  readOnly,
}: {
  notes: Note[];
  creatingNewNote?: boolean;
  currentlyEditingNote?: Note;
  clearNewNote?: () => void;
  deleteNote?: (note: Note) => void;
  setCurrentlyEditing?: (note: Note, e: any) => void;
  clearCurrentlyEditing?: () => void;
  readOnly?: boolean;
}) => {
  return (
    (notes.length > 0 || !!creatingNewNote) && (
      <Section>
        <SectionTitle underline>Notes</SectionTitle>
        {!creatingNewNote ? null : (
          <NoteView
            key="newNote"
            note={currentlyEditingNote}
            selected
            removeable
            onBlur={clearNewNote}
            onDelete={deleteNote}
          />
        )}
        {notes.map((note) => (
          <NoteView
            key={note.id}
            note={note}
            selected={note.isEqual(currentlyEditingNote)}
            onSelect={setCurrentlyEditing}
            onBlur={clearCurrentlyEditing}
            onDelete={deleteNote}
            readOnly={readOnly}
          />
        ))}
      </Section>
    )
  );
};
